export default __webpack_public_path__ + "static/media/A4 large 12.c4fd4778.jpg";